var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 250,
    viewBox: "0 0 192 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.542 0H35.5417C16.0808 0 0.25 19.625 0.25 43.75V250L70.8333 206.25L141.417 250V137.5H191.833V43.75C191.833 19.625 176.002 0 156.542 0ZM171.667 112.5H141.417V43.75C141.417 33.4125 148.203 25 156.542 25C164.881 25 171.667 33.4125 171.667 43.75V112.5Z",
    fill: "#35AFFC",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmarkIcon.7665fb4630df384cfa2a9ac28c827034.svg";
export { ForwardRef as ReactComponent };